import Footer from "./footer";
import { type ReactNode } from "react";
// import Navbar from "./navbar";
import InjectLenis from "../core/inject-lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import Navbar from "./navbar";
gsap.registerPlugin(ScrollTrigger);
const Layout = ({ children }: { children?: ReactNode }) => {
  return (
    <>
      <InjectLenis />
      <Navbar></Navbar>
      <main className="w-full h-auto flex flex-col max-w-full overflow-hidden pb-32">
        {children}
      </main>
      <Footer></Footer>
    </>
  );
};

export default Layout;
